import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    teamLeaderId: string;
    userIds: string[];
};

export const schemaUserResolver_AreAdvisersInTeam = z.boolean();

export type SchemaUserResolver_AreAdvisersInTeam = z.infer<typeof schemaUserResolver_AreAdvisersInTeam>;

export type UserResolver_AreAdvisersInTeam = Resolver<Arguments, SchemaUserResolver_AreAdvisersInTeam>;
